// extracted by mini-css-extract-plugin
export default {"replaceIcon":"GTExdS","projectSelectTooltip":"x_cJKZ","links":"eIpbgT","link":"YjAvag","projectName":"EE4xzu"};